import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpService } from '../../services/HttpService';
import { catchError } from 'rxjs/operators';
import { LocalStorageService } from 'angular-2-local-storage';

@Component({
    selector: 'app-login-form',
    templateUrl: './login.component.html',
    styleUrls: ['./login.componen.scss']
})

export class LoginComponent implements OnInit {
    constructor(private router: Router,
        private http: HttpService,
        private localStorage: LocalStorageService) {

    }

    userForm: FormGroup;
    result: string;
    errorMessage: string;
    hasError = false;

    login($event, userForm) {
        userForm.submitted = true;
        this.hasError = false;
        this.errorMessage = '';

        if (!userForm.valid) {
            return;
        }

        const model = {
            email: userForm.value.email,
            password: userForm.value.password,
            persistent: userForm.value.persistent
        };

        this.http.post('/authorization/signin', model)
            .pipe(catchError(error => this.handleError(error)))
            .subscribe(result => {
                this.localStorage.set('user-roles', result.userRoles);
                this.localStorage.set('user-identity', result.identity);
                this.localStorage.set('token', result.token);
                this.localStorage.set('userName', result.userName);

                if (result.userRoles.length !== 0) {
                    this.router.navigate(['/admin/home']);
                }
                else {
                    this.router.navigate(['/user/profile']);
                }
            });
    }

    handleError(error: any): any {
        this.hasError = true;
        this.errorMessage = error.error;
    }

    ngOnInit(): void {
        this.userForm = new FormGroup({
            email: new FormControl(),
            password: new FormControl(),
            persistent: new FormControl(false)
        });
    }
}
